import PropTypes from 'prop-types';

export default PropTypes.oneOf(['topleft', 'topright', 'bottomleft', 'bottomright']);


//////////////////
// WEBPACK FOOTER
// ./~/react-leaflet/es/propTypes/controlPosition.js
// module id = 140
// module chunks = 0